import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LANDING } from "@/constants/testIds";
import { LOGO_URL, PLAY_STORE_URL } from "@/lib/constants";

const NAV_ITEMS = [
  { id: "how", label: "How it works", testId: LANDING.headerNavFeatures },
  { id: "education", label: "Education", testId: LANDING.headerNavEducation },
  { id: "professional", label: "Professional", testId: LANDING.headerNavProfessional },
  { id: "cards", label: "Credit Cards", testId: LANDING.headerNavCards },
  { id: "faq", label: "FAQ", testId: LANDING.headerNavFaq },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAFAF7]/85 border-b border-[#E5E5E0]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid={LANDING.headerLogo}
          className="flex items-center group"
        >
          <img
            src={LOGO_URL}
            alt="EMDpay"
            className="h-10 sm:h-11 md:h-12 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={item.testId}
              className="text-sm text-[#4A4A4A] hover:text-[#0A0A0A] transition-colors duration-200 font-medium"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={LANDING.headerCtaInstall}
            className="inline-flex items-center gap-2 rounded-full bg-[#F25C2A] hover:bg-[#D9481C] text-white px-5 py-2.5 text-sm font-semibold shadow-[0_8px_24px_-8px_rgba(242,92,42,0.6)] transition-all active:scale-95"
          >
            Install Now
            <span className="-mr-1">→</span>
          </a>
        </div>

        <button
          type="button"
          aria-label="Toggle menu"
          data-testid={LANDING.headerMobileMenuToggle}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-[#E5E5E0] bg-white"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-[#E5E5E0] px-5 py-6 space-y-1">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={() => setOpen(false)}
              data-testid={`${item.testId}-mobile`}
              className="block text-base text-[#0A0A0A] font-medium py-3 border-b border-[#F1F1ED] last:border-0"
            >
              {item.label}
            </a>
          ))}
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${LANDING.headerCtaInstall}-mobile`}
            className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#F25C2A] text-white px-5 py-3 text-sm font-semibold"
          >
            Install Now →
          </a>
        </div>
      )}
    </header>
  );
};
